import { RootState } from "../../../store";
import { CurrentBudgetType } from "../../budgetsSlice";

export const currentBudgetSelector = (
  state: RootState,
): CurrentBudgetType | null => {
  return state.budgets.currentBudget;
};
